import React from 'react';
import ldr from '../../../src/loader2.gif'

export const Loader = ({ height = '100vh' }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#EDF2F9',
        // padding: '14%',
        height: height,
      }}
    >
      {/* <img src="/loader2.gif" /> */}
      <img src={ldr} />

      <div
        style={{
          fontSize: '19px',
          fontWeight: 700,
          color: 'rgb(70 132 175)',
          marginTop: '-3.2rem',
          marginRight: '5px',
        }}
      >
        Loading
      </div>
    </div>
  );
};



// Old code

// import { Center, Container, Spinner } from '@chakra-ui/react';
// import React from 'react';
// export const Loader = () => {
//     return (
//         <Container maxWidth={1100} py={6}>
//             <Center minH={'100%'} maxWidth={1100} px={4} py={40} mr={15} bg="white" rounded="lg"   >
//                 <Spinner color='teal' size='xl' />
//             </Center>
//         </Container>
//     )
// }
